import { proxy } from 'valtio';

export const defaultHasSelection = false;

/**
 * This status records whether any items are selected on the board.
 * This is needed as we would like to disable the "Zoom to selection" button
 * when nothing is selected, and we would like to do this from zoom controls
 * (i.e. outside of the WebGL renderer).
 */
export const currentSelectionStatus: Record<string, boolean> = proxy({
  hasSelection: defaultHasSelection,
});
